import React, { useEffect, useState } from "react";
import { Input, Select, Upload } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { connect } from "react-redux";
import ImgCrop from "antd-img-crop";
import { beforeThumbnailUpload } from "../../utils/uploadFileToCloudflare";
import { fetchCoinsList } from "../../store/actions/coinsListActions";

const { Option } = Select;
const CreateUpdateForm = ({
  handlePayloadChange,
  payload,
  coinsList,
  category,
  fetchCoinsList,
  thumbnailURL,
  handleUpload,
}) => {
  const [opportunityName, setOpportunityName] = useState("");
  const [description, setDescription] = useState("");
  const [type, setType] = useState("");
  const [playLink, setPlayLink] = useState("");
  const [externalLink, setExternalLink] = useState("");
  const [yieldValue, setYieldValue] = useState("");
  const [coins, setCoins] = useState([]);
  const [contractAge, setContractAge] = useState("");
  const [risk, setRisk] = useState("");
  const [allocation, setAllocation] = useState("");
  const [currentTVL, setCurrentTVL] = useState("");
  const [longDescription, setLongDescription] = useState("");

  useEffect(() => {
    fetchCoinsList();
  }, [fetchCoinsList]);

  useEffect(() => {
    if (category === "editOpportunity" && payload) {
      setOpportunityName(payload.opportunityName);
      setDescription(payload.description);
      setLongDescription(payload.longDescription);
      setType(payload.type); 
      setPlayLink(payload.playLink);
      setExternalLink(payload.externalLink);
      setYieldValue(payload.yield);
      setCoins(payload.coins || []);
      setContractAge(payload.contractAge);
      setRisk(payload.risk);
      setCurrentTVL(payload.currentTVL); // Already in millions from PassiveIncome.jsx
      setAllocation(payload.allocation);
    }
  }, [payload, category]);

  const handleChange = (e, type) => {
    if (type === "opportunityName") {
      setOpportunityName(e.target.value);
      handlePayloadChange({...payload, opportunityName: e.target.value});
    }

    if (type === "type") {
      setType(e.target.value);
      handlePayloadChange({...payload, type: e.target.value});
    }

    if (type === "playLink") {
      setPlayLink(e.target.value);
      handlePayloadChange({...payload, playLink: e.target.value});
    }

    if (type === "description"){
      setDescription(e.target.value);
      handlePayloadChange({...payload, description: e.target.value});
    }

     if (type === "longDescription"){
      setLongDescription(e.target.value);
      handlePayloadChange({...payload, longDescription: e.target.value});
    }

    if (type === "externalLink") {
      setExternalLink(e.target.value);
      handlePayloadChange({...payload, externalLink: e.target.value});
    }

    if (type === "yield") {
      setYieldValue(e.target.value);
      handlePayloadChange({...payload, yield: Number(e.target.value)});
    }

    if (type === "coins") {
      // e contains array of coin ids
      const selectedCoins = e.map(coinId => {
        const coin = coinsList.find(c => c.id === coinId);
        return coin ? {
          name: coin.name,
          image: coin.image
        } : null;
      }).filter(Boolean);
      
      setCoins(selectedCoins);
      handlePayloadChange({...payload, coins: selectedCoins});
    }

    if (type === "contractAge") {
      setContractAge(e.target.value);
      handlePayloadChange({...payload, contractAge: Number(e.target.value)});
    }

    if (type === "risk") { 
      setRisk(e.target.value);
      handlePayloadChange({...payload, risk: e.target.value});
    }

    if (type === "currentTVL") {
      setCurrentTVL(e.target.value);
      handlePayloadChange({
        ...payload,
        currentTVL: Number(e.target.value)
      });
    }

    if (type === "allocation") {
      setAllocation(e.target.value);
      handlePayloadChange({...payload, allocation: parseFloat(e.target.value)});
    }
  }

  return (
    <div>
      <div>
        <label>Opportunity Name</label>
        <Input
          value={opportunityName}
          defaultValue={opportunityName}
          onChange={(e) => handleChange(e, "opportunityName")}
        />
      </div>

      <div style={{ marginTop: 15 }}>
        <label>Coins</label>
        <Select
          mode="multiple"
          style={{ width: "100%" }}
          placeholder="Select coins"
          value={coins.map(c => {
            // Find the coin id by name for proper selection
            const coin = coinsList.find(coin => coin.name === c.name);
            return coin ? coin.id : null;
          }).filter(Boolean)}
          onChange={(value) => handleChange(value, "coins")
          }
        >
          {coinsList?.map((coin) => (
            <Option key={coin.id} value={coin.id}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <img src={coin.image} alt={coin.name} style={{ width: '20px', height: '20px' }} />
                {coin.name} ({coin.symbol?.toUpperCase()})
              </div>
            </Option>
          ))}
        </Select>
      </div>

      <div style={{marginTop: 15}}>
        <label>Description</label>
        <Input.TextArea 
          value={description}
          defaultValue={description} 
          onChange={(e) => handleChange(e, "description")}
          maxLength={150}
          placeholder="Max 150 characters"
          rows={3}
        />
      </div>

      <div style={{marginTop: 15}}>
        <label>Long Description</label>
        <Input.TextArea 
          value={longDescription}
          defaultValue={longDescription} 
          onChange={(e) => handleChange(e, "longDescription")}
          maxLength={1000}
          placeholder="Description for sidemenu"
          rows={5}
        />
      </div>

      <div style={{marginTop: 15}}>
        <label>Type</label>
        <Select 
          style={{ width: '100%' }} 
          value={type} 
          onChange={(value) => handleChange({ target: { value } }, "type")}
        >
          <Option value="">Select a type</Option>
          <Option value="flutuante">Flutuante</Option>
          <Option value="prefixado">Pré-fixado</Option>
        </Select>
      </div>

      <div style={{ marginTop: 15 }}>
        <label>Risk</label>
        <Input value={risk} onChange={(e) => handleChange(e, "risk")} />
      </div>

      <div style={{ marginTop: 15 }}>
        <label>Yield</label>
        <Input type="number" value={yieldValue} onChange={(e) => handleChange(e, "yield")} />
      </div>

      <div style={{ marginTop: 15 }}>
        <label>Contract Age (days)</label>
        <Input type="number" value={contractAge} onChange={(e) => handleChange(e, "contractAge")} />
      </div>

      <div style={{ marginTop: 15 }}>
        <label>Current TVL (in millions)</label>
        <Input
          type="number"
          value={currentTVL}
          onChange={(e) => handleChange(e, "currentTVL")}
          placeholder="Enter value in millions (e.g., 100 for $100M)"
        />
      </div>

      <div style={{ marginTop: 15 }}>
        <label>Allocation</label>
        <Input type="number" step="0.01" value={allocation} onChange={(e) => handleChange(e, "allocation")} />
      </div>

      <div style={{marginTop: 15}}>
        <label>Play Link</label>
        <Input 
          value={playLink}
          defaultValue={playLink}
          onChange={(e) => handleChange(e, "playLink")}
        />
      </div>

      <div style={{ marginTop: 15 }}>
        <label>Thumbnail</label>
        <div className="thumbnail-container">
          <ImgCrop
            grid
            rotate
            aspect={16 / 9}
            quality={0.8}
            crop={{ x: 0, y: 0 }}
          >
            <Upload
              name="thumbnail"
              listType="picture-card"
              accept="image/png, image/jpg, image/jpeg"
              className="avatar-uploader"
              showUploadList={false}
              beforeUpload={beforeThumbnailUpload}
              onChange={(upload) => handleUpload(upload)}
            >
              {thumbnailURL ? (
                <img
                  src={thumbnailURL || null}
                  alt="avatar"
                  style={{ width: "100%", height: "200px" }}
                />
              ) : (
                <PlusOutlined />
              )}
            </Upload>
          </ImgCrop>
        </div>
      </div>

      <div style={{marginTop: 15}}>
        <label>External Link</label>
        <Input 
          value={externalLink}
          defaultValue={externalLink}
          onChange={(e) => handleChange(e, "externalLink")}
        />
      </div>

    </div>
  );
};

const mapStateToProps = (state) => ({
  coinsList: state.coinsList.coinsList,
});

export default connect(mapStateToProps, {
  fetchCoinsList
})(CreateUpdateForm);
